<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>路径规划</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#driving-routing"
                   title="驾车路线规划" />
      <anchor-link href="#walking-routing"
                   title="步行路线规划" />
      <anchor-link href="#riding-routing"
                   title="骑行路线规划" />
      <anchor-link href="#electrobike-routing"
                   title="电动车路线规划" />
      <anchor-link href="#electrobike-routing"
                   title="电动车路线规划" />
    </anchor>
    <div id="content-containter">
      <h1>路线规划</h1>
      <span class="time fixPRD">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            路线规划API是通过HTTP协议访问远程服务的接口，提供骑行、步行、驾车查询及行驶距离计算服务，用于实现路径规划功能的开发。</p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          无需展现地图的场景下，进行线路查询 </li>
        <li>
          根据返回线路数据，自行绘制线路或开发线路导航。
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <div id="driving-container">
        <h2 id="driving-routing">驾车路线规划</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>驾车路线规划API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/routeplan/driving?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>POST</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="150">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th>
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>origin</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p>起点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点经纬度坐标</p>
                </td>
                <td>
                  <p>经纬度之间以逗号","分隔，如117.500244, 40.417801 经纬度小数点不超过6位。</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>id</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点POI ID</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>destination</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p>终点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="2">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点经纬度坐标</p>
                </td>
                <td>
                  <p>经纬度之间以逗号","分隔，如117.500244, 40.417801 经纬度小数点不超过6位。</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>id</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>终点POI ID</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>strategy</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>驾车算路策略</p>
                </td>
                <td>
                  <p>FASTEST：时间最短<br>AVOID_CONGESTION：躲避拥堵 （考虑实时路况）</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>FASTEST</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>waypoints</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>途经点</p>
                </td>
                <td>
                  <p>途径点坐标串，默认支持1个有序途径点。多个途径点坐标按顺序以英文分号“;”分隔。最大支持16个途经点。</p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>show_fields</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果控制</p>
                </td>
                <td>
                  <p>
                    <font data-size="14"
                          style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                      <ul style="list-style-type:disc;list-style-position:inside;">
                        <li>duration</li>
                        <li>polyline</li>
                        <li>step</li>
                        <li>tmc</li>
                      </ul><br>2、多个字段间采用“|”进行分割；<br>3、show_fields未设置时，只返回基础信息distance
                    </font>
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="4">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th width="140">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“OK”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>route</p>
                </td>
                <td>
                  <p>array</p>
                </td>
                <td>
                  <p>结果列表</p>
                </td>
                <td>
                  <p>导航路径结果列表</p>
                </td>
              </tr>
              <tr>
                <td rowspan="20">
                  <p></p>
                </td>
                <td colspan="3">
                  <p>origin</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>destination</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>终点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>方案整体距离</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>duration</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>方案整体耗时</p>
                </td>
                <td>
                  <p>单位：秒</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>tolls</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>整体路段收费</p>
                </td>
                <td>
                  <p>单位：元 -1为不知道，0是不收费</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>traffic_light_count</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>方案中红绿灯个数</p>
                </td>
                <td>
                  <p>单位：个</p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>polyline</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>路线经纬度序列</p>
                </td>
                <td>
                  <p>
                  <ul style="list-style-type:disc;list-style-position:inside;">
                    <li>返回值包含起终点坐标</li>
                    <li>起终点坐标可能不在实际道路上，使用时可以考虑通过效果绘制区分</li>
                    <li>格式: polyline为经过压缩的经纬度序列字符串，格式为：
                      坐标1经度 , 坐标1纬度 , 坐标2经度 , 坐标2纬度 , 坐标3经度 , 坐标3纬度…</li>
                  </ul>
                  <span>
                    例如 127.496637,50.243916,-345,-1828,19867,-26154
                    坐标1的经度和纬度为原始未被压缩过的，之后的使用前向差分进行压缩，解压方法如下：
                  </span>
                  <ul class="service-example">
                    <li>var coors=[127.496637,50.243916,-345,-1828,19867,-26154];</li>
                    <li v-text="'for (var i = 2; i < coors.length ; i++) {'"></li>
                    <li>&nbsp;&nbsp;&nbsp;coors[i] = coors[i-2] + coors[i]/1000000;</li>
                    <li>}</li>
                  </ul>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>steps</p>
                </td>
                <td>
                  <p v-text="'array<step>'"></p>
                </td>
                <td>
                  <p>路线分段</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>step</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p></p>
                </td>
                <td>
                  <p>instruction</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>行使指示</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>distance</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>分段距离信息</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>road_name</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>分段道路名称</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>orientation</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>进入道路方向</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>tmcs</p>
                </td>
                <td>
                  <p v-text="'array<tmc>'"></p>
                </td>
                <td>
                  <p>设置后可返回分段路况详情</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>tmc</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>tmc_distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>从当前坐标点开始step中路况相同的距离</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>tmc_status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>路况等级</p>
                </td>
                <td>
                  <p>严重拥堵4; 拥堵3; 缓慢2; 畅通1; 无路况-1</p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>polyline_idx</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>阶段路线坐标点串在方案路线坐标点串的位置</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="1">
                  <p>point_cnt</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>坐标点个数</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <p><strong>body之中的样例</strong></p>
        <div class="service-example">
          <pre><p><code class="json"></code></p></pre>
        </div>
      </div>
      <div id="walking-container">
        <h2 id="walking-routing">步行路线规划</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>步行路线规划API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/routeplan/walking?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>POST</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>origin</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p calss="fixPRD">起点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">起点经纬度坐标</p>
                </td>
                <td>
                  <p>经纬度之间以逗号","分隔，如117.500244, 40.417801 经纬度小数点不超过6位。</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>destination</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p>终点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">终点经纬度坐标</p>
                </td>
                <td>
                  <p>同起点</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>show_fields</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果控制</p>
                </td>
                <td>
                  <p>
                    <font data-size="14"
                          style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                      <ul style="list-style-type:disc;list-style-position:inside;">
                        <li>polyline</li>
                      </ul><br>2、多个字段间采用“|”进行分割（目前仅一个字段）；<br>3、show_fields未设置时，只返回基础信息distance
                    </font>
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>名称</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th>
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>route</p>
                </td>
                <td>
                  <p>array</p>
                </td>
                <td>
                  <p>返回结果</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td>
                  <p>origin</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>destination</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>终点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>路线距离</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>duration</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>使用固定速度计算的时间，步行速度5.0km/h</p>
                </td>
                <td>
                  <p>单位：秒</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>polyline</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>路线经纬度序列</p>
                </td>
                <td>
                  <p>
                  <ul style="list-style-type:disc;list-style-position:inside;">
                    <li>返回值包含起终点坐标</li>
                    <li>起终点坐标可能不在实际道路上，使用时可以考虑通过效果绘制区分</li>
                    <li>格式: polyline为经过压缩的经纬度序列字符串，格式为：
                      坐标1经度 , 坐标1纬度 , 坐标2经度 , 坐标2纬度 , 坐标3经度 , 坐标3纬度…</li>
                  </ul>
                  例如 127.496637,50.243916,-345,-1828,19867,-26154<br>
                  坐标1的经度和纬度为原始未被压缩过的，之后的使用前向差分进行压缩，解压方法如下：
                  <ul class="service-example">
                    <li>var coors=[127.496637,50.243916,-345,-1828,19867,-26154];</li>
                    <li v-text="'for (var i = 2; i < coors.length ; i++) {'"></li>
                    <li>&nbsp;&nbsp;&nbsp;coors[i] = coors[i-2] + coors[i]/1000000;</li>
                    <li>}</li>
                  </ul>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <p><strong>body之中的样例</strong></p>
        <div class="service-example">
          <pre><p><code class="json"></code></p></pre>
        </div>
      </div>
      <div id="riding-container">
        <h2 id="riding-routing">骑行路线规划</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>骑行路线规划API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/routeplan/riding?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>POST</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>origin</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p calss="fixPRD">起点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">起点经纬度坐标</p>
                </td>
                <td>
                  <p>经纬度之间以逗号","分隔，如117.500244, 40.417801 经纬度小数点不超过6位。</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>destination</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p>终点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">终点经纬度坐标</p>
                </td>
                <td>
                  <p>同起点</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>show_fields</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果控制</p>
                </td>
                <td>
                  <p>
                    <font data-size="14"
                          style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                      <ul style="list-style-type:disc;list-style-position:inside;">
                        <li>polyline</li>
                      </ul><br>2、多个字段间采用“|”进行分割（目前仅一个字段）；<br>3、show_fields未设置时，只返回基础信息distance
                    </font>
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th width="90">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>route</p>
                </td>
                <td>
                  <p>array</p>
                </td>
                <td>
                  <p>返回结果</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td>
                  <p>origin</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>destination</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>终点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>路线距离</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>duration</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>路段耗时</p>
                </td>
                <td>
                  <p>单位：秒</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>polyline</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>路线经纬度序列</p>
                </td>
                <td>
                  <p>
                  <ul style="list-style-type:disc;list-style-position:inside;">
                    <li>返回值包含起终点坐标</li>
                    <li>起终点坐标可能不在实际道路上，使用时可以考虑通过效果绘制区分</li>
                    <li>格式: polyline为经过压缩的经纬度序列字符串，格式为：<br>
                      坐标1经度 , 坐标1纬度 , 坐标2经度 , 坐标2纬度 , 坐标3经度 , 坐标3纬度…</li>
                  </ul>
                  例如 127.496637,50.243916,-345,-1828,19867,-26154
                  坐标1的经度和纬度为原始未被压缩过的，之后的使用前向差分进行压缩，解压方法如下：
                  <ul class="service-example">
                    <li>var coors=[127.496637,50.243916,-345,-1828,19867,-26154];</li>
                    <li v-text="'for (var i = 2; i < coors.length ; i++) {'"></li>
                    <li>&nbsp;&nbsp;&nbsp;coors[i] = coors[i-2] + coors[i]/1000000;</li>
                    <li>}</li>
                  </ul>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <p><strong>body之中的样例</strong></p>
        <div class="service-example">
          <pre><p><code class="json"></code></p></pre>
        </div>
      </div>
      <div id="electrobike-container">
        <h2 id="electrobike-routing">电动车路线规划</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>电动车路线规划API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/routeplan/electrobike?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>POST</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>参数名</strong></p>
                </th>
                <th width="90">
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>origin</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p calss="fixPRD">起点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">起点经纬度坐标</p>
                </td>
                <td>
                  <p>经纬度之间以逗号","分隔，如117.500244, 40.417801 经纬度小数点不超过6位。</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>destination</p>
                </td>
                <td>
                  <p>struct</p>
                </td>
                <td>
                  <p>终点属性</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="1">
                  <p></p>
                </td>
                <td colspan="1">
                  <p>location</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p calss="fixPRD">终点经纬度坐标</p>
                </td>
                <td>
                  <p>同起点</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>show_fields</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>返回结果控制</p>
                </td>
                <td>
                  <p>
                    <font data-size="14"
                          style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                      <ul style="list-style-type:disc;list-style-position:inside;">
                        <li>polyline</li>
                      </ul><br>2、多个字段间采用“|”进行分割（目前仅一个字段）；<br>3、show_fields未设置时，只返回基础信息distance
                    </font>
                  </p>
                </td>
                <td>
                  <p>否</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th width="100">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td>
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td>
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>route</p>
                </td>
                <td>
                  <p>array</p>
                </td>
                <td>
                  <p>返回结果</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td>
                  <p>origin</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>起点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>destination</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>终点坐标</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>路线距离</p>
                </td>
                <td>
                  <p>单位：米</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>duration</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>路段耗时</p>
                </td>
                <td>
                  <p>单位：秒</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>polyline</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>路线经纬度序列</p>
                </td>
                <td>
                  <p>
                  <ul style="list-style-type:disc;list-style-position:inside;">
                    <li>返回值包含起终点坐标</li>
                    <li>起终点坐标可能不在实际道路上，使用时可以考虑通过效果绘制区分</li>
                    <li>格式: polyline为经过压缩的经纬度序列字符串，格式为：<br>
                      坐标1经度 , 坐标1纬度 , 坐标2经度 , 坐标2纬度 , 坐标3经度 , 坐标3纬度…</li>
                  </ul>
                  例如 127.496637,50.243916,-345,-1828,19867,-26154<br>
                  坐标1的经度和纬度为原始未被压缩过的，之后的使用前向差分进行压缩，<br>
                  解压方法如下：
                  <ul class="service-example">
                    <li>var coors=[127.496637,50.243916,-345,-1828,19867,-26154];</li>
                    <li v-text="'for (var i = 2; i < coors.length ; i++) {'"></li>
                    <li>&nbsp;&nbsp;&nbsp;coors[i] = coors[i-2] + coors[i]/1000000;</li>
                    <li>}</li>
                  </ul>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <p><strong>body之中的样例</strong></p>
        <div class="service-example">
          <pre><p><code class="json"></code></p></pre>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
import Walking from './Walking.vue'
import Electrobike from './Electrobike.vue'
import Riding from './Riding.vue'
export default {
  components: {
    Anchor,
    AnchorLink,
    Walking,
    Electrobike,
    Riding
  },
  data() {
    return {
      jsonData: [
        {
          key: '用户的key',
          origin: [
            {
              location: '116.4678,40.01136'
            }
          ],
          destination: [
            {
              location: '116.47155,40.021592'
            }
          ]
        }
      ]
    }
  },
  mounted() {
    for (let i = 0; i < document.querySelectorAll('.json').length; i++) {
      let btn = document.querySelectorAll('.json')[i]
      btn.textContent = JSON.stringify(this.jsonData, null, '  ')
    }
  }
}
</script>
<style lang="less" scoped>
@import '../document.less';
#content-containter {
  width: 788px;
}

.title-wrap {
  position: absolute;
  right: 0px;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
</style>
